// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"91a630fb","598":"4399b130","703":"d93128e4","787":"3b5f9b79"}[chunkId] + ".chunk.js";
};